/* eslint-disable */
import React, { Component } from "react";
import { batchActions } from "redux-batched-actions";
import logo_reverse from "../images/logo-hepsijet-footer.png";
import styled from "styled-components";
import { Isa_error } from "./Base"
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Container from '@material-ui/core/Container';

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © HX BI '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const styles = theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url(https://source.unsplash.com/1600x900/?nature,water)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    width: '80%',
    margin: '0 auto',
    marginTop: '50%',
    transform: 'translateY(-40%)',
    textAlign: 'center'
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  }
});

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  handleLogin = ({ username, password }) => {
    this.setState({ loading: true });
    this.props.task_request({
      login: true,
      action: "login",
      payload: { username, password },
      success: result => {
        if (!result.id_token) {
          this.setState({ loading: false });
          return this.props.upsert({
            model: "Settings",
            payload: {
              id: 0,
              error: result.message
            }
          })
        }
        localStorage.setItem("id_token", result.id_token);
        window.location.href = '/dashboard/main';
      }
    });
  };
  render() {
    const { classes } = this.props;
    const username = this.props.Session.Settings.withId(0).username;
    const password = this.props.Session.Settings.withId(0).password;
    const error = this.props.Session.Settings.withId(0).error;
    let message = undefined;
    if (error) {
      message = <Isa_error style={{ padding: 0 }} >{error}</Isa_error>
    }
    return (
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image} />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <div className={classes.paper}>
            <img src={logo_reverse} style={{ width: "175px", marginBottom: 20 }} alt="logo" />
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            {message}
            <div className={classes.form}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Username"
                name="username"
                autoFocus
                value={username}
                onChange={e =>
                  this.props.upsert({
                    model: "Settings",
                    payload: {
                      id: 0,
                      username: e.target.value
                    }
                  })
                }
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                value={password}
                onChange={e =>
                  this.props.upsert({
                    model: "Settings",
                    payload: {
                      id: 0,
                      password: e.target.value
                    }
                  })
                }
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={e => this.handleLogin({ username, password })}
                disabled={this.state.loading}
              >
                Sign In
              </Button>
              <Box mt={5}>
                <Copyright />
              </Box>
            </div>
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(Login);


// WEBPACK FOOTER //
// ./src/components/Login.js